import { Dispatch, SetStateAction } from 'react';
import { API } from 'apis/index';
import { message } from 'antd';
import { del, getViaAuth, postViaAuth, put, responseValidator } from 'apis/api';
import { PaginationList } from 'core/domain';
import {
    AddBalancerTransaction,
    BalancerTransaction,
    EditBalancerTransaction,
    LossAndProfitReport,
} from 'core/domain/balancer-transaction/balancer-transaction';

export const getAllBalancerTransactions = (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: any,
    page: number,
    pageSize: number,
    query: string,
) => {
    setLoading(true);
    getViaAuth<PaginationList<BalancerTransaction>>(
        `${API.balancerTransaction.getAll}/${page}/${pageSize}${query}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
        }
    });
};

export const getBalancerTransactionById = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    id: string,
    setData: Dispatch<SetStateAction<any>>,
) => {
    setLoading(true);
    getViaAuth(`${API.balancerTransaction.getById}/${id}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData({ ...response.value, side: response.value.side.id });
        }
    });
};

export const addBalancerTransaction = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: AddBalancerTransaction,
    onComplete?: () => void,
) => {
    setLoading(true);
    await postViaAuth(API.balancerTransaction.add, data).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            onComplete && onComplete();
        }
    });
};

export const editBalancerTransaction = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: EditBalancerTransaction,
    onComplete?: () => void,
) => {
    setLoading(true);
    put(API.balancerTransaction.update, data).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            onComplete && onComplete();
        }
    });
};

export const removeBalancerTransaction = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    id: string,
    onComplete?: () => void,
) => {
    setLoading(true);
    await del(`${API.balancerTransaction.delete}/${id}`, {}).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            message.success('تراکنش با موفقیت حذف شد');
            onComplete && onComplete();
        }
    });
};

export const getLossAndProfitReport = (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<LossAndProfitReport | undefined>>,
    query?: string,
    onComplete?: (res: LossAndProfitReport) => void,
) => {
    setLoading(true);
    getViaAuth<LossAndProfitReport>(`${API.balancerTransaction.lossAndProfitReport}${query}`)
        .then((res) => {
            setLoading(false);
            if (responseValidator(res.status)) {
                setData(res.value as LossAndProfitReport);
                onComplete && onComplete(res.value as LossAndProfitReport);
            }
        })
        .finally(() => setLoading(false));
};
